import {gql} from "@apollo/client";
import {InsuranceNotificationInput} from "../../domain";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {format} from "date-fns-tz";
import {LOCAL_DATE_FORMAT, showToast} from "common";


const GRAPHQL_MUTATION = gql`
mutation submitAuthInsuranceNotification($input: AuthInsuranceNotificationInput) {
    submitAuthInsuranceNotification(input: $input) {
        guid
    }
}`;

type AuthInsuranceNotificationInput = InsuranceNotificationInput & {
    authorizationGuid: string;
}

const sanitizePayload = (formValues: InsuranceNotificationInput, authorizationGuid: string): AuthInsuranceNotificationInput => {
    const insuranceInactiveDate = formValues.insuranceInactiveDate
        ? format(new Date(formValues.insuranceInactiveDate), LOCAL_DATE_FORMAT)
        : '';

    return {
        insuranceInactiveDate,
        additionalInformation: formValues.additionalInformation || '',
        authorizationGuid,
    };
};

export function useAuthInsuranceNotification(authorizationGuid: string) {
    const {execute} = useMutation$<{ input: AuthInsuranceNotificationInput }, void>(GRAPHQL_MUTATION);
    const submitAuthInsuranceNotification = useCallback(async function (formValues: InsuranceNotificationInput | null) {
        if (formValues == null) {
            return;
        }

        try {
            await execute({
                variables: {
                    input: sanitizePayload(formValues, authorizationGuid),
                }
            });
            showToast.success(
                'Insurance Notification request successfully submitted. The Request can be tracked in the "Submitted Requests" section and a request number ID will be available shortly.'
            );
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit Insurance Notification: ${errors.message || errors[0]?.message}`);
            }
        }
    }, [authorizationGuid, execute]);

    return {
        submitAuthInsuranceNotification
    };
}
